import { Button, Form, Input } from "antd"
import { useNavigate } from "react-router"
import { forgotPassword } from "@/services/passport/passport.service"
import { useState } from "react"

export const ForgotPassword = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [isSend, setSend] = useState(false)

  const toLogin = () => {
    navigate('/login')
  }

  const toResetPassword = async (values) => {
    await forgotPassword(values.email)
    setSend(true)
  }

  if (isSend) {
    return <div className="mt-2">
      <div>Please check your E-mail to reset your password.</div>
      <Button onClick={toLogin} style={{width: '80%'}} className="mt-2">
        To Login
      </Button>
    </div>
  }

  return <Form
    form={form}
    onFinish={toResetPassword}
  >
    <Form.Item
      name="email"
      label="E-mail"
      rules={[
        {
          type: 'email',
          message: 'The input is not valid E-mail!',
        },
        {
          required: true,
          message: 'Please input your E-mail!',
        },
      ]}
    >
      <Input />
    </Form.Item>
     <div className="flex-center mt-2">
      <Button type="primary" htmlType="submit" style={{width: '80%'}}>
        Continue
      </Button>
    </div>
    <div className="flex-center mt-2">
      <Button onClick={toLogin} style={{width: '80%'}}>
        To Login
      </Button>
    </div>
  </Form>
}